"use client";
import React from "react";
import styles from './LandRegistrationGuide.module.css';
import Heading from "@/components/molecules/Heading";
import { ICaseNotFoundBlock } from "@/page-builder/fragments/CaseNotFoundBlock/types";
import { motion } from "framer-motion";
import { convertLexicalWithInternalLinks } from "@/lib/lexical";
import BupiLinkButton from "@/components/atoms/linkButton";
import { getAccessibleImageProps } from "@/lib/image-alt";

export const CaseNotFoundBlock: React.FC<ICaseNotFoundBlock> = ({
  title,
  description,
  image,
  ctaButton,
  faqs
}) => {
  return (
    <section
      className={`${styles["card-not-found-block"]} -mb-96  py-64 md:py-96 bg-[#F1F6F3] sapce-y-32 md:space-y-64 text-[#2B363C]`}
    >
      <div
        className={`mx-auto container grid grid-cols-1 md:grid-cols-8 md:items-center gap-32`}
      >
        <div
          className={`relative flex col-span-4 justify-end order-1`}
        >
          <motion.img
            src={image?.url || ""}
            {...getAccessibleImageProps(image?.alt)}
            className="w-full h-auto z-0"
            initial={{ opacity: 0, x: -80 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              x: { duration: 2, ease: "easeOut" },
              opacity: { duration: 1.5 }
            }}
          />
        </div>
        <div
          className={`flex col-span-4 flex-col justify-center space-y-8 order-2`}
        >
          <Heading title={title} />
          <div
            dangerouslySetInnerHTML={{ __html: convertLexicalWithInternalLinks(description as any ) }}
            className="text-m-regular text-neutral-900 py-8 prose prose-ul:my-0 marker:text-neutral-900"
          />
          
          <BupiLinkButton
            link={ctaButton?.url || "#"}
            label={ctaButton?.label || ""}
            target={ctaButton?.target}
            hasIcon
            leadingIcon="agora-line-arrow-right-circle"
          />
        </div>
      </div>
      <div className="mt-32 md:mt-0 mx-auto container grid grid-cols-1 md:grid-cols-2 gap-32">
        {
          faqs?.map((faq, index) => (
            <div key={index} className="space-y-4">
              <h2 className="text-l-bold md:text-xl-bold xl:text-2xl-bold">{faq?.question}</h2>
              <div>
                <div
                  dangerouslySetInnerHTML={{ __html: convertLexicalWithInternalLinks( faq?.answer as any ) }}
                  className="text-l-regular py-8 prose prose-ul:my-0 marker:text-neutral-900"
                />
              </div>
            </div>
          ))
        }
      </div>
    </section >
  );
};
